<template>
  <div>
      <div class="mx-4">
      <v-label >Техническая поддержка</v-label>
      </div>
       <v-list-item>

                    <v-list-item-icon>
                        <v-icon>mdi-email</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>

                        <v-list-item-title><a href="mailto:info@sistemagorod.ru">info@sistemagorod.ru</a>
                        </v-list-item-title>
                        <v-list-item-subtitle>Адрес электронной почты</v-list-item-subtitle>

                    </v-list-item-content>

                </v-list-item>

                <v-list-item>

                    <v-list-item-icon>
                        <v-icon>mdi-phone</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>

                        <v-list-item-title><a href="tel:385-220-28-20">(385 2) 20-28-20</a></v-list-item-title>
                        <v-list-item-subtitle>Номер телефона</v-list-item-subtitle>

                    </v-list-item-content>

                </v-list-item>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>